// src/components/CompleteProfile.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../../layout";

const CompleteProfile = () => {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/complete-profile`,
        {
          token,
          name,
          password,
        }
      );
      setMessage(response.data.message);
      navigate("/signup"); // Weiterleitung nach der Profilerstellung
    } catch (error) {
      setMessage("Profile completion failed");
    }
  };

  return (
    <Layout>
      <div className="CardContainerTop">
        <div className="CardContainer">
          <div className="CardContainerTitle">
            <h2>Vervollständige dein Profil</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <label>
              Name:
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>
            <label>
              Password:
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
            <button className="btn-gl" type="submit">
              Complete Profile
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default CompleteProfile;
